import script from "./colorCombinInqTab.vue?vue&type=script&setup=true&name=coloCombinInqTab&lang=js"
export * from "./colorCombinInqTab.vue?vue&type=script&setup=true&name=coloCombinInqTab&lang=js"

import "./colorCombinInqTab.vue?vue&type=style&index=0&id=fafaa720&lang=css"

const __exports__ = script;

export default __exports__